export const urls = {
  googleApi: {
    geocode: "https://maps.googleapis.com/maps/api/geocode/json"
  }
};
